import { EmailConfirmation } from '@features/auth/registration/components/EmailConfirmation';
import { useTranslation } from 'react-i18next';

export const RegisterEmailConfirmation = () => {
	const { t } = useTranslation();

	return (
		<EmailConfirmation
			checkEmailText={t('checkEmail')}
			emailSuccessText={t('emailSuccess')}
			checkEmailVerifyText={t('checkEmailVerify')}
			emailLoadText={t('emailLoad')}
			emailIssueText={t('emailIssue')}
			resendEmailText={t('resend')}
			goBackLoginText={t('goBack')}
			checkEmailClassName="text-primary underline"
			goBackLoginClassName="text-primary underline"
			showArrow={true}
		/>
	);
};
